import XKcarTypeScroll from './src/carTypeScroll.vue'

XKcarTypeScroll.install = function (Vue) {
  Vue.component(XKcarTypeScroll.name, XKcarTypeScroll)
}

export default XKcarTypeScroll



// WEBPACK FOOTER //
// ./src/components/module/carTypeScroll/index.js